import { render, staticRenderFns } from "./relatorioPrestacaoDeConta.vue?vue&type=template&id=264a7d14"
import script from "./relatorioPrestacaoDeConta.vue?vue&type=script&lang=js"
export * from "./relatorioPrestacaoDeConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports